<template>
  <Form
    ref="form"
    :model="params"
    col="6"
    :rules="rules"
    :label-width="labelWidth"
    :label-position="labelPosition"
  >
    <Row type="flex">
      <Col v-bind="grid">
        <FormItem label="分类" prop="category_id">
          <Select
            size="small"
            v-model="params.category_id"
            clearable
            placeholder="请选择分类"
          >
            <Option
              v-for="item in categoryList"
              :value="item.id"
              :key="item.id"
            >
              {{ item.name }}
            </Option>
          </Select>
        </FormItem>
      </Col>
      <Col v-bind="grid">
        <FormItem label="状态" prop="status">
          <Select
            size="small"
            v-model="params.status"
            clearable
            placeholder="请选择状态"
          >
            <Option value="1">未读</Option>
            <Option value="0">已读</Option>
          </Select>
        </FormItem>
      </Col>
      <Col v-bind="grid">
        <FormItem label="反馈时间" prop="date" label-for="date">
          <DatePicker
            size="small"
            v-model="params.date"
            clearable
            type="daterange"
            :options="dateOptions"
            placeholder="请选择反馈时间"
            v-width="'100%'"
          />
        </FormItem>
      </Col>

      <Col v-bind="grid" class="ivu-text-right">
        <FormItem>
          <ButtonGroup size="small">
            <Button type="primary" @click="handleSubmit">查询</Button>
            <Button @click="handleReset">重置</Button>
          </ButtonGroup>
          <!-- <a v-font="14" class="ivu-ml-8" @click="collapse = !collapse">
            <template v-if="!collapse">
              展开
              <Icon type="ios-arrow-down" />
            </template>
            <template v-else>
              收起
              <Icon type="ios-arrow-up" />
            </template>
          </a> -->
        </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
import { mapState } from 'vuex'
import dataFilterMixin from '@/mixins/data-filter'
import api from '@/api'

export default {
  data() {
    return {
      grid: {
        xl: 6,
        lg: 6,
        md: 8,
        sm: 24,
        xs: 24,
      },
      categoryList: [],
      params: {
        keyword: '',
        category_id: '',
        type: '',
        status: '',
        date: [],
      },
      rules: {},
    }
  },
  mixins: [dataFilterMixin],
  computed: {
    ...mapState('admin/layout', ['isMobile']),
    labelWidth() {
      return this.isMobile ? undefined : 88
    },
    labelPosition() {
      return this.isMobile ? 'top' : 'right'
    },
  },
  methods: {
    // 取分类列表
    handleGetCategoryList() {
      api.feedback.category
        .list({
          status: 1,
        })
        .then((data) => {
          if (!data) return
          this.categoryList = data.feedback_category_list || []
        })
        .catch(() => {})
    },

    handleSubmit() {
      // console.log(this.params)
      this.params.page = 1
      this.$emit('on-submit', this.params)
    },
    handleReset() {
      this.$refs.form.resetFields()
      // this.$emit('on-reset')
    },
  },
  mounted() {
    this.handleGetCategoryList()
  },
}
</script>
